// GENERATED FILE - DO NOT MODIFY
import { DeliveryAddressModel } from "api/models/company/delivery-address-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class DeliveryAddressProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetDeliveryAddresses(filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<DeliveryAddressModel[] | null> {
        const uri = this.buildUri(
            "/addressspecifications",
            null,
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: DeliveryAddressModel[] | null = await this.get<DeliveryAddressModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.DeliveryAddressModel");
        return data;
    }

    public async GetCustomerDeliveryAddresses(customerId: string | null, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<DeliveryAddressModel[] | null> {
        const uri = this.buildUri(
            "/addressspecifications-customer",
            null,
            { customerId: (customerId === null || customerId === undefined) ? undefined : customerId, filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: DeliveryAddressModel[] | null = await this.get<DeliveryAddressModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.DeliveryAddressModel");
        return data;
    }
}
